const t = {
  name: "--pf-v6-c-description-list--m-horizontal__term--width",
  value: "fit-content(20ch)",
  var: "var(--pf-v6-c-description-list--m-horizontal__term--width)"
};
export {
  t as c_description_list_m_horizontal__term_width,
  t as default
};
